import { isTimeRange } from "@@/shared/date-time/time-range";
import { getTimeOfDay } from "@@/utilities/date-and-time/time-of-day";
import type { Shipment } from "../../shipment/shipment";

//Incomplete and not complete, routifics api is weird
//https://routific-platform.readme.io/reference#routific-projects-api

type RoutificProject = {
    _id: string; //GETTING
    id: string; //ON CREATE
    name: string;
    date: string;
    updateTime: string;
    isLocked: boolean;

    visits: Record<string, Visit>;
    fleet: Record<string, GetDriver>;
};

type Visit = {
    _id: string;
    customNotes: CustomNotes;
};

type PostDriver = {
    name: string;
    start_location: Location;
    // end_location: Location;
    shift_start: string;
    shift_end: string;
    phone_number: string;
    speed: number;
    capacity: number;
    types: string[];
    break: Break;
};

type Break = {
    start: string;
    end: string;
};

type Location = {
    address: string;
    coords: Coords;
};

type Coords = {
    lat: number;
    lng: number;
};

type GetDriver = {
    _id: string;
    name: string;
    "start-location": Location;
    "end-location": Location;
    "phone-number": string;
    "shift-start": string;
    "shift-end": string;
    speed: number;
    capacity: number;
    types: string[];
    breaks: Break[];
    status: string;
};

export type Stop = {
    name: string;
    location: Location;
    start: string;
    end: string;
    duration: number;
    types: string[];
    load: number;
    priority: boolean;
    phone_number?: string;
    phone?: string;
    email?: string;
    notes: string;
    notes2: string;
    custom_notes: CustomNotes;
    customNotes: CustomNotes;
};

export type CustomNotes = {
    kolli: string;
    handlare: string;
    zone: string;
};
const convertDriver = (driver: GetDriver) => {
    return {
        name: driver.name,
        start_location: {
            address: driver["start-location"].address,
            coords: driver["start-location"].coords,
        },

        phone_number: driver["phone-number"],
        shift_start: driver["shift-start"],
        shift_end: driver["shift-end"],

        speed: driver.speed,
        types: driver.types,
    } as PostDriver;
};

const generateProviderPickup = (shipment: Shipment) => {
    const address = shipment.origin.address;
    const from = getTimeOfDay(shipment.pickup);

    const to = shipment.slot ? getTimeOfDay(shipment.slot.start) : "";

    const coords = address.geoLocation
        ? ({
              lat: address.geoLocation?.location.geometry.coordinates[0],
              lng: address.geoLocation?.location.geometry.coordinates[1],
          } as Coords)
        : null;

    const stop = {
        name: shipment.origin.senderName,
        location: {
            address:
                address.addressRows.join(" ") +
                ", " +
                address.zipCode +
                " " +
                address.city,
            coords: coords,
        },
        start: from,
        end: to,

        duration: 1,

        types: [shipment.destination.deliveryZone.shortIdentifier],
        notes: shipment.origin.notesToDeliverer,
        notes2: "",
        custom_notes: {
            handlare: shipment.origin.senderName,
            kolli: shipment.shipmentReference,
            zone: shipment.destination.deliveryZone.shortIdentifier,
        },
        customNotes: {
            handlare: shipment.origin.senderName,
            kolli: shipment.shipmentReference,
            zone: shipment.destination.deliveryZone.shortIdentifier,
        },
    } as Stop;

    return stop;
};

const generateDeliveryStop = (shipment: Shipment) => {
    const address = shipment.destination.address;

    const from = shipment.slot ? getTimeOfDay(shipment.slot.start) : "";
    const to =
        shipment.slot && isTimeRange(shipment.slot)
            ? getTimeOfDay(shipment.slot.end)
            : "";

    const coords = address.geoLocation
        ? ({
              lat: address.geoLocation?.location.geometry.coordinates[0],
              lng: address.geoLocation?.location.geometry.coordinates[1],
          } as Coords)
        : null;

    const stop = {
        name: shipment.destination.recipientName,
        location: {
            address:
                address.addressRows.join(" ") +
                ", " +
                address.zipCode +
                " " +
                address.city,
            coords: coords,
        },
        start: from,
        end: to,

        duration: 5,
        phone_number: shipment.destination.contact.phone.phoneNumber,
        phone: shipment.destination.contact.phone.phoneNumber,
        email: shipment.destination.contact.email?.emailAddress,
        types: [shipment.destination.deliveryZone.shortIdentifier],
        notes: shipment.destination.notesToDeliverer,
        notes2: shipment.destination.addressDetails,
        custom_notes: {
            handlare: shipment.origin.senderName,
            kolli: shipment.shipmentReference,
            zone: shipment.destination.deliveryZone.shortIdentifier,
        },
        customNotes: {
            handlare: shipment.origin.senderName,
            kolli: shipment.shipmentReference,
            zone: shipment.destination.deliveryZone.shortIdentifier,
        },
        load: 0,
        priority: false,
    } as Stop;

    return stop;
};

export { convertDriver, generateDeliveryStop, generateProviderPickup };
export type { Coords, PostDriver, RoutificProject };
